module.exports = __webpack_public_path__ + "img/chat.2b0f858c.svg";